import gsap from "gsap";
import { gsapDebug, gsapDebugSlider } from "./gsapDebug";

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                 1. Text Scramble
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

function textScramble(el) {
  const scrmbleSpan = el.querySelectorAll("span");
  const scrmbleSpanNot = el.querySelectorAll('span:not([data-char="."]');

  gsap.set(scrmbleSpan, { yPercent: -103, autoAlpha: 1 });

  const tl = gsap.timeline();

  tl.to(scrmbleSpan, {
    duration: 1,
    yPercent: 0,
    stagger: 0.05,
    ease: "expo.inOut",
  });

  tl.to(scrmbleSpanNot, {
    duration: 1,
    yPercent: 103,
    stagger: 0.1,
    ease: "expo.inOut",
  });
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                 2. Text Appear Y
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

function appearY(el) {
  const tl = gsap.timeline();
  const span = el.querySelectorAll("span");
  const duration = el.getAttribute("data-duration")

  tl.from(span, {
    autoAlpha: 0,
    yPercent: 130,
    stagger: 0.2,
    duration: duration,
    ease: "power2.out",
  });
}


/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                 2. GROW BOTTOM
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

function growB(el) {
  const tl = gsap.timeline({ onUpdate: gsapDebugSlider });
  gsapDebug(tl);
  const span = el.querySelectorAll("span");
  

  tl.to(span, {
    rotateX: 0,
    y: 0,
    x: 0,
    opacity: 1,
    stagger: .06,
    duration: .8,
    ease: "power3.inOut"
  });
}

export { textScramble, appearY, growB };
